import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import EventIcon from '@mui/icons-material/Event';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

const StyledMenu = styled((props: MenuProps) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === 'light'
                ? 'rgb(55, 65, 81)'
                : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.primary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));

export default function CustomizedMenus({
    statusFilter,
    onStatusChange,
}: {
    statusFilter: string;
    onStatusChange: (status: string) => void;
}) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleSelect = (value: string) => {
        setAnchorEl(null);
        onStatusChange(value);
    };

    return (
        <div>
            <Button
                id="demo-customized-button"
                aria-controls={open ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                color="inherit"
                disableElevation
                size="small"
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}
            >
                {statusFilter === '' ? 'Status' : 'Status: ' + statusFilter}
            </Button>
            <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                    'aria-labelledby': 'demo-customized-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem onClick={() => handleSelect('')} disableRipple>
                    <span style={{ fontWeight: 'bold' }}>All</span>
                </MenuItem>
                <MenuItem onClick={() => handleSelect('booked')} disableRipple>
                    <EventAvailableIcon />
                    Booked
                </MenuItem>
                <MenuItem onClick={() => handleSelect('pending')} disableRipple>
                    <EventIcon />
                    Pending
                </MenuItem>
                <MenuItem
                    onClick={() => handleSelect('pending_observation')}
                    disableRipple
                >
                    <EventAvailableIcon />
                    Pending Observation
                </MenuItem>
                <MenuItem
                    onClick={() => handleSelect('observed')}
                    disableRipple
                >
                    <EventAvailableIcon />
                    Observed
                </MenuItem>
                <MenuItem
                    onClick={() => handleSelect('cancelled')}
                    disableRipple
                >
                    <EventBusyIcon />
                    Cancelled
                </MenuItem>
                <MenuItem onClick={() => handleSelect('missed')} disableRipple>
                    <EventBusyIcon />
                    Missed
                </MenuItem>
                <MenuItem onClick={() => handleSelect('error')} disableRipple>
                    <EventBusyIcon />
                    Errored
                </MenuItem>
            </StyledMenu>
        </div>
    );
}
